import { render, staticRenderFns } from "./ModalCreate.vue?vue&type=template&id=78c0510e&scoped=true&"
import script from "./ModalCreate.vue?vue&type=script&lang=js&"
export * from "./ModalCreate.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreate.vue?vue&type=style&index=0&id=78c0510e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c0510e",
  null
  
)

export default component.exports